import styled from 'styled-components';
import { BasketPxDetailsStyled } from '../BasketPxDetailsStyled';
import { rem } from 'polished';

export const BasketPxDetailsOV = styled(BasketPxDetailsStyled)`
    .summary {
        .leftSection,
        .rightSection {
            .summaryTitle,
            .summaryValue {
                font-size: ${({ theme }) => theme.fontSizes.textMedium};
            }

            .summaryDescription {
                font-size: ${({ theme }) => theme.fontSizes.textSupBase};
            }
        }
    }

    .continue {
        .continueLabel {
            font-size: ${({ theme }) => theme.fontSizes.textMedium};
        }
    }
  
  .status {
        .statusIcon {
            svg {
                top: ${rem(35)};
            }
        }

        .statusLabel {
            font-size: ${({ theme }) => theme.fontSizes.textMedium};
            line-height: ${rem(20)};
        }

        .trash {
            font-size: ${({ theme }) => theme.fontSizes.h5};

            svg {
                margin-bottom: ${rem(-3)};
            }
        }
    }
`;
